import suiteService from 'qreventos-suite/services';
import invitacionService from 'qreventos-suite/invitaciones';

class SuiteConfig {
    evento:number = 906;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
    clientId: string = '76339a08-253c-4e51-8c6f-3bef69f8f77a-906';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  

      invitacionService.clientId = this.clientId;
      invitacionService.token = this.token;
    }
}

export default new SuiteConfig();
